import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import { formatCurrencywithamount } from "../utilities/helper"; //formatCurrency(amount, currency = "INR", locale = "en-IN")
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Autoplay, Pagination } from "swiper/modules";
import "../styles/styles.css";
import constants from "../utilities/constants";

const Slider = ({ items, handleClick, TickImg }) => {
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  return (
    <div
      onClick={() =>
        handleClick({
          title: constants.SingleOrder,
          actionTitle: null,
          orderId: items?.orderId,
        })
      }
      className="h-full relative cursor-pointer  "
    >
      <Swiper
        direction="vertical"
        slidesPerView={1}
        spaceBetween={10}
        freeMode={true}
        autoplay={{
          delay: 5000, // 5 seconds
          disableOnInteraction: false, // keeps autoplay active even when the user interacts
        }}
        pagination={{
          className: "bullett",
          clickable: true,
          bulletClass: "swiper-pagination-bullet",
          bulletActiveClass: "swiper-pagination-bullet-active",
        }}
        modules={[FreeMode, Autoplay, Pagination]}
        breakpoints={{
          320: {
            direction: "horizontal",
            slidesPerView: 1,
          },
          768: {
            direction: "vertical",
            slidesPerView: 1,
          },
        }}
        className="swiper-custom max-md:h-fit w-full md:!h-[200px]"
      >
        <section className="flex absolute flex-row md:w-[580px] m-2 p-2 rounded-lg justify-start items-center">
          {items.Sliders?.slice(0, 5).map((item, index) => (
            <SwiperSlide key={index}>
              <div
                style={{ boxShadow: " rgba(0, 0, 0, 0.13)" }}
                className="flex flex-row border md:h-[180px] h-[200px] md:w-[580px] m-2 md:p-2 p-1 rounded-lg justify-start items-center"
              >
                <div className="me-3 ">
                  <img
                    src={item?.image}
                    className="max-md:!w-40 max-md:!h-40 w-40 h-40"
                    alt="allorder-img"
                  />
                </div>
                <div className="md:py-5 w-full flex flex-col items-start">
                  {item?.orderStatus?.map((statusItem) => (
                    <>
                    <div className="flex items-center">
                      <div className="relative" key={statusItem}>
                        <span
                          className={`me-2 px-3 py-1 rounded-[50px] text-[12px] font-semibold bg-[#00AA63] text-white ${
                            statusItem === "Shipped"
                              ? "bg-[#1E91CF] text-white"
                              : statusItem === "Canceled" ||
                                statusItem === "Failed"
                              ? "bg-[#FF9933] text-white"
                              : statusItem === "Refunded" ||
                                statusItem === "Delivered"
                              ? "bg-[#00AA63] text-white pe-7"
                              : null
                          }`}
                        >
                          {statusItem}
                        </span>

                        {(statusItem === "Refunded" ||
                          statusItem === "Delivered") && (
                          <img
                            src={TickImg}
                            className="w-4 h-4 absolute right-2 transition -translate-x-2 -translate-y-5"
                            alt="tickimg"
                          />
                        )}
                      </div>
                      {/* Gift Tag */}
                      <div className="">
                        <img
                          src={constants.DEFAULT_IMAGE + "/gift.svg"}
                          alt="Gift"
                        />
                      </div>
                    </div>
                    </>
                  ))}

                  <span className="block mt-2 font-tiemann font-bold md:text-xl text-base text-left">
                    {item?.title}
                  </span>
                  <span className="block text-[#262626] font-bold md:text-xl text-base">
                    {formatCurrencywithamount(
                      item?.amount,
                      selectedcountrySuccess?.currencyAlias
                        ? selectedcountrySuccess?.currencyAlias
                        : "",
                      selectedcountrySuccess?.iso
                        ? `en-${selectedcountrySuccess?.iso}`
                        : "",
                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                    )}
                  </span>
                  <div className="bg-[#EBEBEB] border-b md:w-[400px] mt-2"></div>
                  <p className="text-left lg:text-sm text-xs font-medium mt-2 text-[#262626]">
                    Order Number :{" "}
                    <span className="underline text-[#4D4D4D]">
                      {item?.ordernumber}
                    </span>
                  </p>
                  <p className="lg:text-sm text-xs font-medium text-[#262626]">
                    Ordered Date : {item?.orderdate}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </section>
      </Swiper>
    </div>
  );
};

export default Slider;
